export class WixHeadersParsingError extends Error {
    constructor(header, value) {
        super(`WixHeadersParsingError: ${header} evaluated with ${JSON.stringify(value)} but should be a string!`);
    }
}
export class WixHeadersValidationError extends Error {
    constructor(type, key, value) {
        super(`WixHeadersValidationError: expected ${key} to be ${type} but got ${JSON.stringify(value)}`);
    }
}
//# sourceMappingURL=errors.js.map